<div class="question-panel question-panel--mini" style="margin: 20px 0 20px;">
  @if (showAddAnother && !showPlayer) {
    <div id="question-add-container">
      <a href="javascript:void(0);" class="question-panel__add" (click)="addAnother()">
        <div class="button-control">
          <svg class="icon"><use xlink:href="#plus-filled"></use></svg><strong>Add Another</strong>
        </div>
      </a>
    </div>
  }

  @if (showPlayer && !showAddAnother) {
    <div id="question-container">
      <app-question-controller
        [question]="activeQuestion"
        [controlCssClass]="'mb-15'"
        (questionAnswer)="onAnswerChange($event)"
        [showLabelQuestionCopy]="true"
        [showLabel]="true">
      </app-question-controller>
      <div class="question-panel__progress opacity-50">
        <div class="progress-line progress-line--sm">
          <div class="progress-line__track">
            <div class="progress-line__bar" id="mini-progress-bar" [ngStyle]="{width: percentage + '%'}"></div>
          </div>
        </div>
      </div>
      <div class="question-panel__nav">
        <a href="javascript:void(0);"
          (click)="goToPrevious()"
          class="question-panel__nav-prev button button--naked"
          [ngClass]="{'is-active': activeQuestion?.previous}">
          <svg class="icon icon--flip"><use xlink:href="#chevron-right"></use></svg>
        </a>
        <a href="javascript:void(0);"
          (click)="removeBenefit()"
          class="question-panel__nav-remove button button--naked is-active">
          Remove
        </a>
        <a href="javascript:void(0);"
          [attr.disabled]="buttonDisabled ? buttonDisabled : null"
          (click)="saveAnswer()"
          class="question-panel__nav-next button button--primary is-active">
          Next
        </a>
      </div>
    </div>
  }
</div>
